import { useAxiosClient } from '..';

export const useSchoolApi = () => {
    const { axiosClient, axiosClientNoResponseIntercept } = useAxiosClient();

    const buildClassCredentialConfig = (classLogin, classToken, classRole) => {
        if (!classLogin || !classToken) {
            return {};
        }

        const headers = {
            "X-Class-Login": classLogin,
            "X-Class-Token": classToken
        };

        if (classRole) {
            headers["X-Class-Role"] = classRole;
        }

        return { headers };
    };

    return {
        schoolList: async (page, itemsPerPage, nameFilter, cityFilter, stateFilter, countryFilter) => (await axiosClient.get(`/v1/school?page=${page}&itemsPerPage=${itemsPerPage}&nameFilter=${nameFilter}&cityFilter=${cityFilter}&stateFilter=${stateFilter}&countryFilter=${countryFilter}`)).data,
        deleteSchool: async (id) => (await axiosClient.delete(`/v1/school/${id}`)),    
        createSchool: async (school) => (await axiosClient.post(`/v1/school`, school)),
        updateSchool: async (school) => (await axiosClient.put(`/v1/school/${school.id}`, school)),
        courseReportSchools: async (classLogin, classToken, classRole) => {
            const config = buildClassCredentialConfig(classLogin, classToken, classRole);
            return (await axiosClientNoResponseIntercept.get(`/v1/school/course-report-filter`, config)).data;
        },
    }
}
